export default __webpack_public_path__ + "static/media/logo-rfh.98c3209f.svg";